import { Link } from 'react-router-dom';
import { useSubscriptionStatus } from '@/hooks/use-subscription';

/** Sticky-ish (just appears at the top of the page content) banner showing
 *  trial days remaining. Renders nothing for active subs or when not in trial.
 *  The colour ramp gets more urgent as the trial closes. */
export function TrialBanner() {
  const { subscription, daysRemaining, isLifetimePro } =
    useSubscriptionStatus();

  if (isLifetimePro) return null;
  if (!subscription || subscription.status !== 'trialing') return null;
  if (daysRemaining === null) return null;

  const tone =
    daysRemaining <= 1 ? 'urgent' : daysRemaining <= 3 ? 'warning' : 'info';

  const styles = {
    urgent: 'bg-red-50 text-red-900 border-red-200',
    warning: 'bg-amber-50 text-amber-900 border-amber-200',
    info: 'bg-blue-50 text-blue-900 border-blue-200',
  }[tone];

  const dot = {
    urgent: 'bg-red-500',
    warning: 'bg-amber-500',
    info: 'bg-blue-500',
  }[tone];

  const message =
    daysRemaining === 0
      ? "Votre essai gratuit se termine aujourd'hui."
      : daysRemaining === 1
        ? 'Il reste 1 jour à votre essai gratuit.'
        : `Il reste ${daysRemaining} jours à votre essai gratuit.`;

  return (
    <div
      className={`mb-4 flex items-center justify-between gap-4 rounded-lg border px-4 py-2.5 text-sm ${styles}`}
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <span className={`h-1.5 w-1.5 rounded-full ${dot} shrink-0`} />
        <span className="font-medium truncate">{message}</span>
      </div>
      <Link
        to="/settings/billing"
        className="shrink-0 rounded-md bg-foreground/90 px-3 py-1.5 text-xs font-semibold text-background hover:bg-foreground transition"
      >
        Choisir un plan
      </Link>
    </div>
  );
}
